const initialState = {
  reportMakerDashboardData: [],
  loadingReportMakerDashboardData: false,
  errorsReportMakerDashboardData: {},
  reportMakerDashboardDataCount: 0,
  reportMakerDashboardDataPermissions: {},
  reportMakerDashboardByUserData: [],
  loadingReportMakerDashboardByUserData: false,
  errorsReportMakerDashboardByUserData: {},
  reportMakerDashboardByUserDataCount: 0,
  reportMakerDashboardByUserDataPermissions: {},
  reportMakerDashboardDetails: [],
  loadingReportMakerDashboardDetails: false,
  errorsReportMakerDashboardDetails: {},
  reportMakerDashboardDetailsCount: 0,
  frontDashboardData: {},
  loadingFrontDashboardData: false,
  errorsFrontDashboardData: {},
  // error.response is undefined for network errors, so track failure explicitly
  frontDashboardDataFailed: false,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_REPORT_MAKER_DASHBOARD_DATA_PENDING":
      return {
        ...state,
        loadingReportMakerDashboardData: true,
        errorsReportMakerDashboardData: {},
      };

    case "GET_REPORT_MAKER_DASHBOARD_BY_USER_PENDING":
      return {
        ...state,
        loadingReportMakerDashboardByUserData: true,
        errorsReportMakerDashboardByUserData: {},
      };

    case "GET_REPORT_MAKER_DASHBOARD_DETAILS_PENDING":
      return {
        ...state,
        loadingReportMakerDashboardDetails: true,
        errorsReportMakerDashboardDetails: {},
        reportMakerDashboardDetails: [],
      };

    case "GET_REPORT_MAKER_DASHBOARD_BY_USER_FULFILLED":
      return {
        ...state,
        loadingReportMakerDashboardByUserData: false,
        reportMakerDashboardByUserData: action.payload,
        errorsReportMakerDashboardByUserData: {},
        reportMakerDashboardByUserDataCount: action.count,
        reportMakerDashboardByUserDataPermissions: action.permissions,
      };

    case "GET_REPORT_MAKER_DASHBOARD_DATA_FULFILLED":
      return {
        ...state,
        loadingReportMakerDashboardData: false,
        reportMakerDashboardData: action.payload,
        errorsReportMakerDashboardData: {},
        reportMakerDashboardDataCount: action.count,
        reportMakerDashboardDataPermissions: action.permissions,
      };
      
    case "GET_REPORT_MAKER_DASHBOARD_DETAILS_FULFILLED":
      return {
        ...state,
        loadingReportMakerDashboardDetails: false,
        reportMakerDashboardDetails: action.payload,
        errorsReportMakerDashboardDetails: {},
        reportMakerDashboardDetailsCount: action.count,
      };

    case "GET_REPORT_MAKER_DASHBOARD_BY_USER_REJECTED":
      return {
        ...state,
        loadingReportMakerDashboardByUserData: false,
        errorsReportMakerDashboardByUserData: action.payload,
      };


    case "GET_REPORT_MAKER_DASHBOARD_DETAILS_REJECTED":
      return {
        ...state,
        loadingReportMakerDashboardDetails: false,
        errorsReportMakerDashboardDetails: action.payload,
      };

    case "GET_REPORT_MAKER_DASHBOARD_DATA_REJECTED":
      return {
        ...state,
        loadingReportMakerDashboardData: false,
        errorsReportMakerDashboardData: action.payload,
      };


    case "GET_FRONT_DASHBOARD_DATA_PENDING":
      return {
        ...state,
        loadingFrontDashboardData: true,
        errorsFrontDashboardData: {},
      };

    case "GET_FRONT_DASHBOARD_DATA_FULFILLED":
      return {
        ...state,
        loadingFrontDashboardData: false,
        frontDashboardData: action.payload || {},
        errorsFrontDashboardData: {},
        frontDashboardDataFailed: false,
      };

    case "GET_FRONT_DASHBOARD_DATA_REJECTED":
      return {
        ...state,
        loadingFrontDashboardData: false,
        errorsFrontDashboardData: action.payload,
        frontDashboardDataFailed: true,
      };

    case "CLEAR_REPORT_MAKER_DASHBOARD_DETAILS":
      return {
        ...state,
        reportMakerDashboardDetails: [],
        loadingReportMakerDashboardDetails: false,
        errorsReportMakerDashboardDetails: {},
        reportMakerDashboardDetailsCount: 0,
      };

    default:
      return state;
  }
};

export default dashboardReducer;
